import LenderNotifications from "./LenderNotifications";

export default LenderNotifications;